




































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { getPageTitle } from '@/router/permission';

@Component({
  name: 'LangSelect',
})
export default class LangSelect extends Vue {
  public static langSelectedEvent = 'lang-selected';

  @Prop({ default: false }) private isMobile!: boolean;

  private items = [
    {
      lang: 'en',
      title: 'English',
    },
    {
      lang: 'ja',
      title: '日本語',
    },
    {
      lang: 'zh',
      title: '简体中文',
    },
    {
      lang: 'zt',
      title: '繁體中文',
    },
    {
      lang: 'ko',
      title: '한국어',
    },
  ];

  private mobileListModel = false;

  get language() {
    return AppModule.language;
  }

  private handleSetLanguage(lang: string, emitEvent: boolean = true) {
    this.$i18n.locale = lang;
    this.$vuetify.lang.current = lang;
    AppModule.SetLanguage(lang);

    let pageTitle = '';
    if (this.$route.meta && this.$route.meta.title) {
      pageTitle = this.$route.meta.title;
    }
    document.title = getPageTitle(pageTitle);

    this.$toast.success(
      this.$t('@comps.lang-select.selected', {
        lang: this.langToTitle(lang),
      }) as string,
      { icon: 'mdi-web' }
    );

    if (emitEvent) {
      this.$emit(LangSelect.langSelectedEvent, lang);
    }
  }

  private handleMobileSetLanguage(lang: string) {
    this.handleSetLanguage(lang, false);
    this.mobileListModel = false;
    this.$emit(LangSelect.langSelectedEvent, lang);
  }

  private langToTitle(lang: string): string {
    const item = this.items.find(item => item.lang === lang);
    return item ? item.title : lang;
  }
}
